



















































































































































































































































































































































































import { ListModel } from "@/shared/models/listModel";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import {
  PropertyOtaModel,
  PropertyOtaStatusEnum,
  AccomodationUnitForOTASetupModel,
  KroatiDeSyncResult,
  AccomodationUnitTypeForOTASetupModel,
} from "./types";
import FormDescription from "@/components/misc/FormDescription.vue";
import { JwtClaims } from "@/store/modules/auth";
import { policyChecker } from "@/shared/roles";
import * as _ from "lodash";
import OtasIframe from "./OtasIframe.vue";
import { RatePlan } from "../calendar/CalendarTypes";
import { OTAChannels, TenantTypesEnum } from "@/shared/models/enums.type";
import LoadingOverlay from "@/components/misc/LoadingOverlay.vue";
import NumericInputImproved from "../numbers/NumericInputImproved.vue";
import { RolesEnum, userHasAnyRole } from "@/shared/roles";

@Component({
  components: {
    FormDescription,
    OtasIframe,
    NumericInputImproved,
    LoadingOverlay,
  },
})
export default class Otas extends Vue {
  @Getter("auth/claims") claims?: JwtClaims;
  get allowedToModifyOTAs() {
    return policyChecker("REQUIRE_TENANT_ADMIN_OR_HIGHER")(this.claims);
  }

  get isSysAdmin() {
    return userHasAnyRole([RolesEnum.SysAdmin])(this.claims);
  }

  @Getter("calendar/nonOBRatePlans") nonOBRatePlans?: RatePlan[];
  @Action("calendar/refreshNonOBRatePlans")
  refreshNonOBRatePlans?: () => Promise<void>;
  get standardRatePlans() {
    return (
      this.nonOBRatePlans?.filter(
        (x) => !x.isDerived && !x.isSpecialOrPackageOffer
      ) ?? []
    );
  }
  get standardAndDerivedRatePlans() {
    return this.nonOBRatePlans?.filter((x) => !x.isSpecialOrPackageOffer) ?? [];
  }

  @Getter("appParams/typeId") tenantTypeId?: number;

  async created() {
    const promises = [];
    if (
      (this.nonOBRatePlans?.length ?? 0) === 0 &&
      this.refreshNonOBRatePlans
    ) {
      promises.push(this.refreshNonOBRatePlans());
    }
    await Promise.all(promises);
  }

  @Prop() propertyId?: number;
  @Prop() propertyName?: string;

  otas: PropertyOtaModel[] = [];
  OTAChannelsEnum = OTAChannels;
  propertyOTAStatusEnum = PropertyOtaStatusEnum;
  loading = true;

  submiting = false;

  @Watch("propertyId", { immediate: true })
  load() {
    if (!this.propertyId) return;

    this.axios
      .get<ListModel<PropertyOtaModel>>(`/properties/${this.propertyId}/otas`)
      .then(
        ({ data }) =>
          (this.otas = data.result.map((x) =>
            Object.assign(new PropertyOtaModel(this.propertyId ?? 0), x)
          ))
      )
      .finally(() => {
        this.loading = false;
        this.otaUpdateLoading = false;
      });

    this.loadUnitTypesForOTASetup();
  }

  isFormValid = false;

  @Ref("formRef") formRef?: {
    resetValidation: () => void;
    validate: () => boolean;
  };

  copyTemplate(idApiKey: string) {
    navigator.clipboard.writeText(idApiKey);

    this.$store.dispatch("showNotification", {
      color: "success",
      message: this.$t("LinkCopiedToClipboard"),
      timeout: 5000,
    });
  }

  otaChanged(ota: PropertyOtaModel, val: boolean) {
    const endpoint = val ? "activate" : "deactivate";
    ota.statusId = val
      ? PropertyOtaStatusEnum.Active
      : PropertyOtaStatusEnum.Deactivated;
    this.otaUpdateLoading = true;
    this.axios
      .post<number>(`/properties/${this.propertyId}/otas/${endpoint}`, {
        otaId: ota.otaId,
      })
      .then()
      .finally(() => {
        this.submiting = false;
        this.load();
      });
  }

  otaUpdateLoading = false;
  otaUpdated(ota: PropertyOtaModel) {
    this.debouncedUpdate(ota);
  }

  debouncedUpdate = _.debounce(this.updateOta, 500);

  updateOta(ota: PropertyOtaModel) {
    this.otaUpdateLoading = true;

    this.axios
      .put(`/properties/${this.propertyId}/otas/${ota.otaId}`, {
        commissionPercent: ota.commissionPercent,
        ownerPaysOTACommission: ota.ownerPaysOTACommission,
        paymentCollectByOTA: ota.paymentCollectByOTA,
        paymentCollectCommission: ota.paymentCollectByOTA
          ? ota.paymentCollectCommission
          : 0,
        ratePlanId: ota.ratePlanId,
        accomodationUnitTypeId: ota.accomodationUnitTypeId,
      })
      .finally(() => {
        this.load();
      });
  }

  enableSwitch() {
    return this.loading && this.submiting;
  }

  otasIframeIsOpen = false;

  @Watch("otasIframeIsOpen")
  otasIframeIsOpenWatch(fresh: boolean, old: boolean) {
    if (!fresh && old) {
      this.otaUpdateLoading = false;
    }
  }

  openOtasIframe() {
    this.otasIframeIsOpen = true;
    this.otaUpdateLoading = true;
  }

  getValue(statusId: number | null) {
    return (
      statusId !== null &&
      (statusId == PropertyOtaStatusEnum.Active ||
        statusId == PropertyOtaStatusEnum.ActivationPending)
    );
  }

  getMessage(statusId: number | null) {
    switch (statusId) {
      case null:
        return [];
      case PropertyOtaStatusEnum.ActivationPending:
        return "PropertyForm.Otas.ActivationPending";
      case PropertyOtaStatusEnum.Active:
        return "PropertyForm.Otas.Active";
      case PropertyOtaStatusEnum.DeactivationPending:
        return "PropertyForm.Otas.DeactivationPending";
    }
  }

  getColor(statusId: number | null) {
    switch (statusId) {
      case null:
        return "default";
      case PropertyOtaStatusEnum.ActivationPending:
        return "primary";
      case PropertyOtaStatusEnum.Active:
        return "success";
      case PropertyOtaStatusEnum.DeactivationPending:
        return "error";
    }
  }

  requiredWith0Allowed(value: any) {
    return !!value || value === 0
      ? true
      : this.$t("Validation.Required").toString();
  }

  wholeNumbersOnly(value: number) {
    return (
      value == null ||
      value == undefined ||
      value % 1 == 0 ||
      this.$t("Validation.MustBeWholeNumber")
    );
  }

  kroatiDeSetupModalOpen = false;
  loadingUnitsForOTASetup = false;
  atraveoSetupModalOpen = false;
  loadingUnitTypesForOTASetup = false;
  unitsForOTASetup: AccomodationUnitForOTASetupModel[] = [];
  unitTypesForOTASetup: AccomodationUnitTypeForOTASetupModel[] = [];

  openKroatiDeSetupModal() {
    this.loadUnitsForOTASetup();
    this.kroatiDeSetupModalOpen = true;
  }

  closeKroatiDeSetupModal() {
    this.kroatiDeSetupModalOpen = false;
    this.unitsForOTASetup = [];
  }
  openAtraveoSetupModal() {
    this.loadUnitTypesForOTASetup();
    this.atraveoSetupModalOpen = true;
  }

  closeAtraveoSetupModal() {
    this.atraveoSetupModalOpen = false;
    this.unitTypesForOTASetup = [];
  }

  loadUnitsForOTASetup() {
    this.loadingUnitsForOTASetup = true;
    this.axios
      .get<AccomodationUnitForOTASetupModel[]>(
        `/AccomodationUnits/GetUnitsForOTASetup`,
        {
          params: {
            propertyId: this.propertyId,
          },
        }
      )
      .then((res) => {
        this.unitsForOTASetup = res.data;
      })
      .finally(() => (this.loadingUnitsForOTASetup = false));
  }

  loadUnitTypesForOTASetup() {
    this.loadingUnitTypesForOTASetup = true;
    this.axios
      .get<AccomodationUnitTypeForOTASetupModel[]>(
        `/AccomodationUnitTypes/GetUnitTypesForOTASetup`,
        {
          params: {
            propertyId: this.propertyId,
          },
        }
      )
      .then((res) => {
        this.unitTypesForOTASetup = res.data;
      })
      .finally(() => (this.loadingUnitTypesForOTASetup = false));
  }

  submitUnitsForOTASetup() {
    const request = {
      accomodationUnits: [...this.unitsForOTASetup],
    };

    request.accomodationUnits.forEach((x) => {
      if (x.kroatiDeId === undefined || (x.kroatiDeId as any) === "")
        x.kroatiDeId = null;
    });

    this.loadingUnitsForOTASetup = true;
    this.axios
      .post(`/AccomodationUnits/AccomodationUnitsOTASetup`, request)
      .then(() => this.closeKroatiDeSetupModal())
      .finally(() => (this.loadingUnitsForOTASetup = false));
  }

  kroatiDeSyncModalOpen = false;
  kroatiDeSyncResult = null as null | KroatiDeSyncResult;
  yearToSync = new Date().getFullYear();
  kroatiDeSyncYearList = [
    {
      text: this.yearToSync.toString(),
      value: this.yearToSync,
    },
    {
      text: (this.yearToSync + 1).toString(),
      value: this.yearToSync + 1,
    },
    {
      text: (this.yearToSync + 2).toString(),
      value: this.yearToSync + 2,
    },
  ];

  kroatiDeSyncInProgress = false;
  submitKroatiDeSync() {
    this.kroatiDeSyncInProgress = true;
    this.axios
      .post<KroatiDeSyncResult>(
        `/properties/${this.propertyId}/otas/kroatidesync/${this.yearToSync}`
      )
      .then((x) => {
        this.kroatiDeSyncResult = x.data;
      })
      .finally(() => (this.kroatiDeSyncInProgress = false));
  }

  get isTenantAnAgency() {
    return this.tenantTypeId == TenantTypesEnum.Agency;
  }
}
